import {ILanguage} from "./ILanguage";

export enum ELanguage {
    FR = 'fr',
    EN = 'en',
    ES = 'es'
}

export const languages: ILanguage[] = [
    {
        languageAbbreviation: ELanguage.FR,
        languageName: "Français",
        flagPath: "./assets/icon/flag/french.png"
    },
    {
        languageAbbreviation: ELanguage.EN,
        languageName: "English",
        flagPath: "./assets/icon/flag/english.png"
    },
    {
        languageAbbreviation: ELanguage.ES,
        languageName: "Español",
        flagPath: "./assets/icon/flag/spain.png"
    }
];
